const GRAMS_PER_OUNCE = 28.349523125;
const ML_PER_FLUID_OUNCE = 29.5735295625;

export const gramsToOunces = (grams) => Number(grams) / GRAMS_PER_OUNCE;

export const millilitersToFluidOunces = (milliliters) =>
  Number(milliliters) / ML_PER_FLUID_OUNCE;

// 4.23 -> "4.2", 1.01 -> "1", 0.35 -> "0.35": one decimal from 1 up, two below, no trailing zeros.
const roundForDisplay = (amount) =>
  String(Number(amount.toFixed(amount >= 1 ? 1 : 2)));

const UNITS = {
  g: { grams: 1 },
  kg: { grams: 1000 },
  ml: { milliliters: 1 },
  l: { milliliters: 1000 },
};

// Turns a product size into the label to show, plus its US equivalent where there is one.
// The number comes from `sizeValue` and the unit from the end of `sizeName`, so both
// "100g" / 100 and "g" / 111 work. Anything it doesn't recognise is shown as written.
//   formatSize("100g", 100)  -> { label: "100 g",   converted: "3.5 oz" }
//   formatSize("150ml", 150) -> { label: "150 ml",  converted: "5.1 fl oz" }
//   formatSize("pcs", 6)     -> { label: "6 pcs",  converted: null }
//   formatSize("Large", null) -> { label: "Large",  converted: null }
export const formatSize = (sizeName, sizeValue) => {
  const name = (sizeName ?? "").trim();
  const unit = name.match(/([a-zA-Z]+)$/)?.[1]?.toLowerCase();
  const nameNumber = name.match(/^(\d+(?:\.\d+)?)/)?.[1];
  const value = Number(sizeValue ?? nameNumber);
  const known = UNITS[unit];
  const hasValue = Number.isFinite(value) && value > 0;

  if (!known || !hasValue) {
    // An unfamiliar unit stored on its own ("oz", "pcs") still needs its number in front.
    const label = hasValue && name && !nameNumber ? `${value} ${name}` : name;
    return { label, converted: null };
  }

  if (known.grams) {
    const grams = value * known.grams;
    return { label: `${value} ${unit}`, converted: `${roundForDisplay(gramsToOunces(grams))} oz` };
  }

  const milliliters = value * known.milliliters;
  return {
    label: `${value} ${unit}`,
    converted: `${roundForDisplay(millilitersToFluidOunces(milliliters))} fl oz`,
  };
};
